import React from "react";

export default function AdminMetricCard({ label, value, sub, tone = "default", testId }) {
  return (
    <div className={`admin-metric admin-metric--${tone}`} data-testid={testId}>
      <div className="admin-metric__label">{label}</div>
      <div className="admin-metric__value">{value}</div>
      {sub && <div className="admin-metric__sub">{sub}</div>}
    </div>
  );
}
